// src/components/PrivateRoute/PrivateRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api, { setToken } from '../../services/api';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

function isExpired(assinatura) {
  if (!assinatura) return true;
  if (assinatura.status === 'EXPIRED') return true;
  if (assinatura.expira_em && new Date(assinatura.expira_em) < new Date()) return true;
  return false;
}

export default function PrivateRoute() {
  const [state, setState] = useState({ checking: true, allowed: false, expired: false });

  // Escuta o evento emitido pelo api.js quando refresh falha — força redirect ao login
  useEffect(() => {
    const handleForceLogout = () => {
      setState({ checking: false, allowed: false, expired: false });
    };
    window.addEventListener('istudo:logout', handleForceLogout);
    return () => window.removeEventListener('istudo:logout', handleForceLogout);
  }, []);

  useEffect(() => {
    let mounted = true;

    const hardLogout = () => {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
      } catch {}
      if (mounted) setState({ checking: false, allowed: false, expired: false });
    };

    const checkExpiration = (data) => {
      // admins, usuários de instituição e tipos não-aluno não precisam de assinatura
      if (data?.tipo && data.tipo !== 'aluno') return false;
      if (data?.instituicao_id) return false;
      return isExpired(data?.assinatura);
    };

    const validateSession = async () => {
      try {
        const hasToken = !!localStorage.getItem('token');

        if (hasToken) {
          const { data } = await api.get('/usuarios/me');
          if (!mounted) return;
          if (checkExpiration(data)) {
            setState({ checking: false, allowed: false, expired: true });
            return;
          }
          setState({ checking: false, allowed: true, expired: false });
          return;
        }

        // 🔄 Não tenho token, mas posso ter cookie rt → tenta refresh manual
        try {
          const { data: refreshData } = await api.post('/auth/refresh');
          const newToken = refreshData?.token;
          if (!newToken) throw new Error('refresh sem token');
          setToken(newToken);

          const { data } = await api.get('/usuarios/me');
          if (!mounted) return;
          if (checkExpiration(data)) {
            setState({ checking: false, allowed: false, expired: true });
            return;
          }
          setState({ checking: false, allowed: true, expired: false });
          return;
        } catch {
          hardLogout();
        }
      } catch {
        hardLogout();
      }
    };

    validateSession();
    return () => { mounted = false; };
  }, []);

  if (state.checking) return <LoadingScreen />;
  if (state.expired) return <Navigate to="/renovar" replace />;
  if (!state.allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
